// Import Packages
import React from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description 
 * @Param       action - object
 * @Param       variables - object variable list
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function NewFile({ action, setOpenVariable, variables, automId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.NEW-FILE.';

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'FILE-NAME')} is_required />
                <TextInput action={action} inputName="fileName" setOpenVariable={setOpenVariable} isRequired
                    variables={variables} fieldType="string" displayName={t(label + 'FILE-NAME')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'FOLDER-PATH')} is_required />
                <TextInput action={action} inputName="folderPath" setOpenVariable={setOpenVariable} isRequired
                    variables={variables} fieldType="string" displayName={t(label + 'FOLDER-PATH')} autom_id={automId} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'SHEET-NAME')} />
                <TextInput action={action} inputName="sheetName" setOpenVariable={setOpenVariable} isRequired={false}
                    variables={variables} fieldType="string" displayName={t(label + 'SHEET-NAME')} />
            </div>

            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN-PATH')} />
                <VariablePicker action={action} inputName="assignToVariable" variables={variables} setOpenVariable={setOpenVariable}
                    filter="string" isRequired={false} />
                <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </div>
    )
}

export default NewFile;
